// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MK_tW","field":"styles_field__3bo4e","fieldCol":"styles_fieldCol__1MwO8","diffCol":"styles_diffCol__2NYrv","diff":"styles_diff__zDod0"};